module.exports = "<div>tttt</div>\r\n<router-outlet (activate)=\"onActivate($event)\" >\r\n  <div>hkjh</div>\r\n</router-outlet>\r\n"